export type ReservedCapacityChangePeriod = 'Monthly' | 'Quarterly' | 'Yearly';

export const ReservedCapacityChangePeriod = {
    Monthly: 'Monthly' as ReservedCapacityChangePeriod,
    Quarterly: 'Quarterly' as ReservedCapacityChangePeriod,
    Yearly: 'Yearly' as ReservedCapacityChangePeriod
};
